import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import {saveAs} from 'file-saver';
import * as ReportModule from 'Modules/ReportModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as ReportActionModel from './Models/ReportActionModel';
import {store} from './../Store';
import {createSerachQuery} from 'Connectors/_main'
import {DEFAULT_PAGE_SIZE} from '../../constants'
import {ReportStore, VehicleStateReportParam} from 'Models/ReportModel'
import {RootState} from 'Redux/Reducers/_RootReducer'

function getCarMainReport(params?: URLSearchParams) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            const getCarMainReportResponse = await ReportModule.Connector.getCarMainReport(params);
            dispatch(getCarMainReportSuccess(getCarMainReportResponse.data, params));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function getTerminalInstallationReport(params?: URLSearchParams) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            const getTerminalInstallationReportResponse = await ReportModule.Connector.getTerminalInstallationReport(params);
            dispatch(getTerminalInstallationReportSuccess(getTerminalInstallationReportResponse.data, params));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function getActiveTerminalsReport(params?: URLSearchParams) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            const getActiveTerminalsReportResponse = await ReportModule.Connector.getActiveTerminalsReport(params);
            dispatch(getActiveTerminalsReportSuccess(getActiveTerminalsReportResponse.data, params));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function getVehiclesStateReport(params?: VehicleStateReportParam) {
    return async (dispatch, getState: () => RootState) => {
        try {
            const { reportStore } = getState();
            const newParams = (params ?? { max: DEFAULT_PAGE_SIZE }) as ReportStore['vehiclesStateReportLatestUrlParams'];
            const searchParams = createSerachQuery(newParams);

            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            const getVehiclesStateReportResponse = await ReportModule.Connector.getVehiclesStateReport(searchParams);
            const allVehiclesStateReports = !params || params.first === 0
              ? getVehiclesStateReportResponse.data.vehiclesState.results
              : [...reportStore.allVehiclesStateReports, ...getVehiclesStateReportResponse.data.vehiclesState.results];
            dispatch(getVehiclesStateReportSuccess(
              getVehiclesStateReportResponse.data,
              newParams,
              allVehiclesStateReports
            ));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function getCarParkingReport(params?: URLSearchParams) {
    return async dispatch => {
        try {
            const getCarParkingReportResponse = await ReportModule.Connector.getCarParkingReport(params);
            dispatch(getCarParkingReportSuccess(getCarParkingReportResponse.data, params));
        } catch (err) {
            //
        }
    };
}

function getCarRideReport(params?: URLSearchParams) {
    return async dispatch => {
        try {
            const getCarRideReportResponse = await ReportModule.Connector.getCarRideReport(params);
            dispatch(getCarRideReportSuccess(getCarRideReportResponse.data, params));
        } catch (err) {
            //
        }
    };
}

function getReportFile(extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            //TODO: check it why it is not working Łukasz Zygmunt   4 weeks ago (February 6th, 2025 2:18 PM) fix#129101(VehicleStateReport): handle properly params for report export
            // const latestParams = createSerachQuery({});
            const latestParams = store.getState().reportStore.latestUrlParams

            latestParams.set('report_extension', extension);
            if (![ReportModule.EnumTypes.ReportType.TERMINAL_INSTALLATION_REPORT, ReportModule.EnumTypes.ReportType.ACTIVE_TERMINALS_REPORT].includes(type)) {
                latestParams.set('report_type', type);
            }
            const reportFileResponse = await ReportModule.Connector.getReportFile(latestParams, type);

            const blob = reportFileResponse.data;
            const contentDisposition = reportFileResponse.headers['content-disposition'];
            const fileExtension = extension.toLowerCase();
            const fromDate = latestParams.get('from')?.split('T')[0] || '';
            const toDate = latestParams.get('to')?.split('T')[0] || '';
            const dateRange = fromDate && toDate ? `${fromDate}_${toDate}` : '';
            let name = `terminal-installation-report${dateRange ? `-${dateRange}` : ''}.${fileExtension}`;
            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    name = match[1].replace(/['"]+/g, '');
                }
            }
            saveAs(blob, name);
            dispatch(getReportFileSuccess());
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
            console.log(err);
        }
    };
}

function getCarRideReportSuccess(carRidesReport: ReportModule.Types.CarRidesReport, latestUrlParams?: URLSearchParams): ReportActionModel.GetCarRidesReport {
    return {
        type: ActionTypes.REPORT.GET_CAR_RIDES_REPORT,
        payload: {
            carRidesReport,
            latestUrlParams
        }
    };
}

function getReportFileSuccess(): ReportActionModel.GetReportFile {
    return {
        type: ActionTypes.REPORT.GET_REPORT_FILE
    };
}

function getCarParkingReportSuccess(carParkingReport: ReportModule.Types.CarParkingReport, latestUrlParams?: URLSearchParams): ReportActionModel.GetCarParkingReport {
    return {
        type: ActionTypes.REPORT.GET_CAR_PARKING_REPORT,
        payload: {
            carParkingReport,
            latestUrlParams
        }
    };
}

function getCarMainReportSuccess(carMainReport: ReportModule.Types.CarMainReport, latestUrlParams?: URLSearchParams): ReportActionModel.GetCarMainReport {
    return {
        type: ActionTypes.REPORT.GET_CAR_MAIN_REPORT,
        payload: {
            carMainReport,
            latestUrlParams
        }
    };
}

function getTerminalInstallationReportSuccess(terminalInstallationReport: ReportModule.Types.TerminalInstallationReport, latestUrlParams?: URLSearchParams): ReportActionModel.GetTerminalInstallationReport {
    return {
        type: ActionTypes.REPORT.GET_TERMINAL_INSTALLATION_REPORT,
        payload: {
            terminalInstallationReport,
            latestUrlParams
        }
    };
}

function getActiveTerminalsReportSuccess(activeTerminalsReport: ReportModule.Types.ActiveTerminalsReport, latestUrlParams?: URLSearchParams): ReportActionModel.GetActiveTerminalsReport {
    return {
        type: ActionTypes.REPORT.GET_ACTIVE_TERMINALS_REPORT,
        payload: {
            activeTerminalsReport,
            latestUrlParams
        }
    };
}

function getVehiclesStateReportSuccess(
  vehiclesStateReport: ReportModule.Types.VehiclesStateReport,
  vehiclesStateReportLatestUrlParams?: ReportStore['vehiclesStateReportLatestUrlParams'],
  allVehiclesStateReports?: ReportModule.Types.VehiclesStateReport['vehiclesState']['results']
): ReportActionModel.GetVehiclesStateReport {
    return {
        type: ActionTypes.REPORT.GET_VEHICLES_STATE_REPORT,
        payload: {
            vehiclesStateReport,
            allVehiclesStateReports,
            vehiclesStateReportLatestUrlParams
        }
    };
}

export {
    getCarMainReport,
    getTerminalInstallationReport,
    getActiveTerminalsReport,
    getCarParkingReport,
    getReportFile,
    getCarRideReport,
    getVehiclesStateReport
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/ReportActions.ts